import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import stringHelper from 'utils/stringHelper';

import Stack from '@mui/material/Stack';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';


import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';



import CircularProgress from '@mui/material/CircularProgress';

import { green } from '@mui/material/colors';


const styles = theme => ({

    cardActions: {
        justifyContent: 'right'
    },


    formControl: {
        margin: 0,
        width: '100%'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }
});


class QualificationCodeAdresseErroneeInconnueInnerForm extends React.Component {


    constructor(props) {
        super(props);

        // Initialisation du state
        this.state = this.getInitialState(props.open);
    }

    getInitialState = (open) => {
        const initialState = {
            open: open,
            societe: '',
            adresse: '',
            commentaire: ''
        };
        return initialState;
    }



    handleChange = (event) => {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };
        
        this.setState(newState);

    }


    handleClickAnswer = (event) => {
        const newState = {
            ...this.state,
            open: true
        };

        this.setState(newState);
    }

    handleClickCancel = (event) => {
        this.setState(this.getInitialState(this.props.open));

        if (this.props.onClickCancelFallback) {
            this.props.onClickCancelFallback();
        }
    }

    handleClickAdresseCorrecte = (event) => {
        const { commentaire } = this.state;

        this.props.onClickSave('', '', commentaire, true );
    }

    handleClickSave = (event) => {
        const { societe, adresse, commentaire } = this.state;

        this.props.onClickSave(societe, adresse, commentaire, false);
    }

        
    render() {
        const { classes, isAdding } = this.props;

        const { open, societe, adresse, commentaire } = this.state;
        
        let sauvegardable = !stringHelper.isNullOrWhitespace(societe) && !stringHelper.isNullOrWhitespace(adresse);
        
        return (

            <React.Fragment>

                <div hidden={open || isAdding}>
                    <Button onClick={this.handleClickAnswer} variant="outlined" >Répondre</Button>
                </div>


                <Card hidden={!open && !isAdding}>

                    <CardContent sx={{ minWidth: '500px' }}>

                        <Stack spacing={1}>

                            <TextField className={classes.formControl}
                                required
                                id="societe"
                                name="societe"
                                label="Nom de la societe"
                                placeholder="Nom de la societe"
                                margin="normal"
                                value={societe}
                                onChange={this.handleChange}
                            />

                            <TextField className={classes.formControl}
                                required
                                id="adresse"
                                name="adresse"
                                label="Adresse de livraison"
                                placeholder="Adresse de livraison"
                                multiline
                                margin="normal"
                                value={adresse}
                                onChange={this.handleChange}
                            />


                            <TextField className={classes.formControl}
                                id="commentaire"
                                name="commentaire"
                                label="Commentaire"
                                placeholder="Commentaire"
                                multiline
                                margin="normal"
                                value={commentaire}
                                onChange={this.handleChange}
                            />

                        </Stack>

                    </CardContent >




                    <CardActions classes={{ root: classes.cardActions }}>
                        <Button
                            variant="contained"
                            color="correct"
                            onClick={this.handleClickAdresseCorrecte}
                        >
                                Adresse correcte - Pas de modification
                        </Button>
                        <Button onClick={this.handleClickCancel} color="primary" >Annuler</Button>
                        <Button
                            onClick={this.handleClickSave}
                            variant="contained"
                            color="secondary"
                            disabled={!sauvegardable || isAdding}
                        >
                            {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                            Enregistrer
                                </Button>
                    </CardActions>


                </Card>
            </React.Fragment>
        );
    }
}
QualificationCodeAdresseErroneeInconnueInnerForm.propTypes = {
    isAdding: PropTypes.bool.isRequired,
    open: PropTypes.bool.isRequired,
    onClickSave: PropTypes.func.isRequired,
    onClickCancelFallback: PropTypes.func.isRequired
};

export default withStyles(styles)(QualificationCodeAdresseErroneeInconnueInnerForm);